import { Button, InputAdornment, Stack, Typography } from "@mui/material";
import { CampaignContext } from "../../Context";
import { useContext, useState } from "react";
import CustomTextInput from "../../../../../global/components/CustomTextInput/CustomTextInput";
import { handleErrorMessage, isTruthy } from "helpers/methods";
import { cloneDeep } from "lodash";
import history from "utils/history";
import viewpaths from "global/constants/ViewPathConstants";
import CustomLoader from "global/components/CustomLoader/CustomLoader";

interface CustomProps {
  setSkipStepOne: Function;
}

const Step1 = (props: CustomProps) => {
  const [formFields, setFormFields] = useState({
    name: {
      value: "",
      error: "",
    },
  });
  const { submitCampaign, setSubmitCampaign, saveAsDraft } =
    useContext(CampaignContext);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const saveCampaignName = async () => {
    try {
      let error = false;
      const clonedFormFields = cloneDeep(formFields);
      if (!isTruthy(clonedFormFields.name.value)) {
        error = true;
        clonedFormFields.name.error = "Please enter the campaign name";
      }
      if (error) {
        return setFormFields(clonedFormFields);
      }
      setIsLoading(true);
      const campaignObject = {
        ...submitCampaign,
        campaign: {
          ...submitCampaign.campaign,
          name: formFields.name.value.trim(),
        },
      };
      setSubmitCampaign(campaignObject);
      const campaignId = await saveAsDraft(campaignObject);
      history.push(
        viewpaths.createRegularCampaignViewPath + `?id=${campaignId}`
      );
      setIsLoading(false);
      props.setSkipStepOne(true);
    } catch (error: any) {
      setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const getPage = () => {
    return (
      <Stack spacing={4}>
        <Stack spacing={1}>
          <Typography variant="h4">Create an email campaign</Typography>
          <Typography variant="body1">
            To get started, please provide a name for your email campaign. This
            will help you easily identify and manage your campaign later on.
          </Typography>
        </Stack>
        <CustomTextInput
          label="Campaign name"
          value={formFields.name.value}
          onChange={(event: any) => {
            const trimmedValue = event.target.value.trimStart();
            setFormFields({
              ...formFields,
              name: {
                value: trimmedValue,
                error: "",
              },
            });
          }}
          error={formFields.name.error}
          required
          placeHolder="Enter the campaign name"
          propsToInputElement={{ minLength: 1, maxLength: 90 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <span style={{ fontSize: "0.75rem" }}>
                  {formFields.name?.value?.length} / 90
                </span>
              </InputAdornment>
            ),
          }}
        />
        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <Button
            variant="text"
            onClick={() =>
              history.push(
                `${
                  viewpaths.campaignsViewPath
                }?page=${1}&rowsPerPage=${10}&status=All&category=all&currentTab=email`
              )
            }
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={saveCampaignName}>
            Create campaign
          </Button>
        </Stack>
      </Stack>
    );
  };

  return (
    <>
      {getPage()}
      <CustomLoader isLoading={isLoading} />
    </>
  );
};

export default Step1;
